import Vue from 'vue';
import axios from 'axios';
import Cookies from 'js-cookie';
import apis from '@/utils/apis';
import store from '../store/index';
import router from '../router/index';

// axios配置
axios.defaults.timeout = 1000000;
axios.defaults.baseURL = '/api/';
axios.defaults.withCredentials = true;

// 过期刷新token
let pending;
let pendingList = [];
function refreshToken(response) {
  console.warn('请求刷新Token');
  if (!pending) {
    pending = true;
    // 请求刷新Token
    store.dispatch('TokenRefresh').then(() => {
      console.warn('刷新Token成功');
      pending = false;
      pendingList.forEach((cb) => cb()); // 释放所有等待
      pendingList = [];
    });
  }
  // 存储所有等待
  return new Promise((resolve) => {
    pendingList.push(() => {
      console.warn('释放等待请求');
      axios.request(response.config).then((res) => {
        resolve(res);
      });
    });
  });
}

// 请求拦截器
axios.interceptors.request.use(
  (req) => {
    req.headers.clientToken = 'Basic YW5kcm9pZDphbmRyb2lk';
    req.headers.Authorization = Cookies.get('token') || '';
    req.headers['x-language-header'] = Cookies.get('langCode') || 'CN';
    req.headers.hostIp = localStorage.hostIp || '192.168.11.132'; // 阿康
    // req.headers.hostIp = localStorage.hostIp || '192.168.11.132'; // 维文
    // 账号登录、微信登录、绑定用户、接口都需要再head带version
    if (apis.Login === req.url || req.url.indexOf(apis.WechatLogin) !== -1 || req.url.indexOf(apis.BindUser) !== -1) {
      req.headers['version'] = 2;
    }
    return req;
  },
  (err) => Promise.reject(err)
);
// 响应拦截器
axios.interceptors.response.use(
  (res) => {
    if (res.data && res.data.code === 0) {
      return res;
    }
    // 408是微信登录跳转绑定
    if (res.data && res.data.code === 408) {
      return res;
    }
    // 刷新token
    if (res.data && res.data.code === 402) {
      return refreshToken(res);
    }
    // 鲁班通上传
    if (res.data && res.data.msg === '操作成功') {
      return res;
    }
    if (res.data && res.data.code) {
      // 401token错误  405token已经完全过期
      if (res.data.code === 401 || res.data.code === 405) {
        store.commit('LOGINOUT');
        Cookies.remove('loginName', { path: '/' });
        Cookies.remove('token', { path: '/' });
        Cookies.remove('tokenTimeOut', { path: '/' });
        // Cookies.remove('langCode', { path: '/' });
        if (router.currentRoute.path !== '/login') {
          router.replace({ path: '/login' });
        }
        return Promise.reject(res.data);
      }
      const vm = new Vue();
      vm.$message.error(res.data.msg || '服务异常');
      return Promise.reject(res.data);
    }
    return res;
  },
  (err) => Promise.reject(err.response)
);
export default axios;
